import { useMemo, useCallback } from 'react';
import { DATA_ADAPTER, PUSH_ADAPTER, APP_ENV } from '../config/adapters';
import { DEMO_TICK_INTERVAL_MS } from '../services/demo/demoTicksConfig';
import { getPlatformStatus } from '../services/firebase/platform';

export function useDevTools() {
  const platform = useMemo(() => getPlatformStatus(), []);

  const sendPushNotification = useCallback(async (payload: Record<string, unknown>) => {
    const { sendPushNotification: send } = await import('../services/firebase/FunctionsService');
    return send(payload);
  }, []);

  return {
    dataAdapter: DATA_ADAPTER,
    pushAdapter: PUSH_ADAPTER,
    appEnv: APP_ENV,
    platform,
    demoTickIntervalMs: DEMO_TICK_INTERVAL_MS,
    sendPushNotification,
  };
}
